import { appServiceApi } from "../../../app/appServiceApi";
import { API_URL } from "../../../constants/apiUrl";
import { GetQueryArgsType } from "../../../types";
import {
  GetAllStatementsDataParamsType,
  GetAllStatementsDataType,
  GetDownloadBankStatementsDataType,
  GetDownloadStatementsDataType,
  GetDownloadStatementsParamsType,
} from "../../../types/portal/statements";

export const statementsApi = appServiceApi.injectEndpoints({
  endpoints: (builder) => ({
    bankRequest: builder.mutation({
      query: (data) => ({
        url: API_URL.bankRequest,
        method: "POST",
        body: data,
      }),
      invalidatesTags: (result) => {
        if (result) return ["GetAllStatements", "GetDownloadStatements"];
        return [];
      },
    }),

    getAllStatements: builder.query<
      GetAllStatementsDataType,
      GetQueryArgsType<GetAllStatementsDataParamsType>
    >({
      query: (queryArgs) => ({
        url: API_URL.getAllStatements,
        params: queryArgs.params,
      }),
      providesTags: ["GetAllStatements"],
    }),

    getDownloadStatements: builder.query<
      GetDownloadStatementsDataType,
      GetDownloadStatementsParamsType
    >({
      query: ({ id }) => ({
        url: `${API_URL.getDownloadStatements}/${id}`,
      }),
      providesTags: ["GetDownloadStatements", "GetAllStatements"],
    }),

    getBankStatementsDownload: builder.query<
      GetDownloadBankStatementsDataType,
      GetDownloadStatementsParamsType
    >({
      query: ({ id }) => ({
        url: `${API_URL.getBankStatementsDownload}/${id}`,
      }),
      providesTags: [
        "GetDownloadStatements",
        "GetAllStatements",
        "GetBankStatementsDownload",
      ],
    }),
  }),
});

export const {
  useBankRequestMutation,
  useGetAllStatementsQuery,
  useLazyGetDownloadStatementsQuery,
  useLazyGetBankStatementsDownloadQuery,
} = statementsApi;
